import axios from 'axios'
import http from '@/axios/http'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const AUTHORIZATION = 'Authorization';

const state = {
  //
  path: ''
};

const mutations = {
  UPDATE_PATH(state, payload) {
    state.path = payload;
  }
};

const getters = {
  path: state => state.path,
};

const actions = {
  updatePath({commit}, path) {
    commit('UPDATE_PATH', path);
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sysInfo.js